export default "__VITE_ASSET__73f8352b__"